const regionNames = [
  'provider',
  'docket_number',
  'reference_number',
  'compressive_strength',
];

export default regionNames;
